import * as React from 'react';

import {
    CustomizeColumnsInsightProps,
    CustomizeColumnsInsightState,
} from './customize-columns.insight.model';
import { NestedNodeSelectInsight } from './nested-node-select.insight.component';
import { NestedNode } from './nested-node-select.insight.model';
import { OptionalColumn } from './optional-column.insight.model';

class CustomizeColumnsInsightImpl extends React.Component<
    CustomizeColumnsInsightProps,
    CustomizeColumnsInsightState
> {
    constructor(props: CustomizeColumnsInsightProps) {
        super(props);

        this._propsToState();
    }

    private _propsToState(): void {
        const mapToNode = (oc: OptionalColumn): NestedNode => {
            return {
                id: oc.id.toString(),
                label: oc.name,
                checked: oc.forced,
                disabled: oc.disabled,
                hidden: oc.hidden,
            };
        };
        const nodes = this.props.columns.map(mapToNode);
        const selection = this.props.selection.map(mapToNode);
        this.state = { nodes, selection };
    }

    render(): React.ReactNode {
        const mapToColumn = (node: NestedNode): OptionalColumn =>
            this.props.columns.find((e) => e.id.toString() === node.id);
        return (
            <NestedNodeSelectInsight
                nodes={this.state.nodes}
                selection={this.state.selection}
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                onChange={(e) =>
                    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                    this.props.onChange &&
                    this.props.onChange({
                        selected: e.selected.map(mapToColumn),
                    })
                }
            />
        );
    }
}

export const CustomizeColumnsInsight = CustomizeColumnsInsightImpl;
